import axios from '../axios'

const patchRescheduleLessonApi = async (eventId, startAt, endAt, dayOfWeek) => {
    return await axios.patch(`api/teacher/events/${eventId}/reschedule-lesson`, { startAt, endAt, dayOfWeek })
}

export default patchRescheduleLessonApi